require('../legacy/embeddedobjectfield.js');
require('../legacy/linkfield.js');



// WEBPACK FOOTER //
// ./client/src/bundles/bundle.js